import { ModelCommon, UserAttributeDef, UserAttributeDefs, toDatePickerFormat, ValidModelType } from '@iotv/datamodel-core';
import { isValidBusinessObject, MapLike, PathDirection } from '@iotv/iotv-v3-types';

const typeName = 'TurbidityDev';

export type TurbidityDevProps = {
  qRCode?: string;
  devEUI?: string;

  version?: string;
};

export class TurbidityDev extends ModelCommon {
  constructor(ob: any) {
    super(ob.type || typeName, ob);
  }

  qRCode?: string;
  devEUI?: string;

  version?: string;

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
      qRCode: { type: 'String', editable: true, label: 'QR Code', name: 'qRCode', description: 'QR code for provisioning' },
      devEUI: { type: 'String', editable: true, label: 'Dev EUI', name: 'devEUI', description: 'Unique device ID' },
      name: { type: 'String', editable: true, label: 'Name', name: 'name', description: 'Name/ type of device' },
      version: { type: 'String', editable: true, label: 'Version', name: 'version', description: 'Version of device' },
    };
  };
}
